export interface ApiResponse<T> {
    ok: boolean;
    data?: T;
    error?: string;
}

export interface SuccessResponse<T> extends ApiResponse<T> {
    ok: true;
    data: T;
}

export interface ErrorResponse extends ApiResponse<any> {
    ok: false;
    error: string;
}

export function isSuccess<T>(apiResponse: ApiResponse<T>): apiResponse is SuccessResponse<T> {
    return apiResponse.ok;
}

export function getDataOrFail<T>(res: ApiResponse<T>): T {
    if (isSuccess(res)) {
        return res.data;
    }
    throw new Error(res.error);
}

export interface PageInfo {
    resultsPerPage: number;
    currentPage: number;
    totalPages: number;
    totalItems: number;
}

export interface PagedResponse<T> extends ApiResponse<T[]> {
    pageInfo: PageInfo;
}

export interface Page<T> {
    data: T[];
    pageInfo: PageInfo;
}

export function getPageOrFail<T>(res: PagedResponse<T>): Page<T> {
    if (isSuccess(res)) {
        return {
            data: res.data,
            pageInfo: res.pageInfo
        };
    }
    throw new Error(res.error);
}